import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "fixed bottom-20 w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "table-cell align-middle text-white text-sm font-bold" }, " カテゴリーとフィルター ")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "absolute w-5 h-5 aspect-square bg-green-lightShow rounded-full right-0 border border-gray-showButton table transform translate-x-1/2 -translate-y-3/4"
}
const _hoisted_4 = { class: "table-cell align-middle text-sm text-white" }
const _hoisted_5 = { class: "py-3 relative h-full" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-bold" }, "カテゴリーとフィルター")
], -1)
const _hoisted_7 = { class: "p-4 space-y-4" }
const _hoisted_8 = { class: "flex justify-between" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "block text-left text-sm font-bold text-gray-showButton" }, " カテゴリーを指定する ", -1)
const _hoisted_10 = { class: "relative mt-1" }
const _hoisted_11 = {
  key: 0,
  class: "block text-left truncate"
}
const _hoisted_12 = {
  key: 1,
  class: "block text-gray-placeholder text-left"
}
const _hoisted_13 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2" }
const _hoisted_14 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 text-white"
}
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "relative mt-1" }
const _hoisted_17 = { class: "flex flex-wrap py-4" }
const _hoisted_18 = { class: "bg-white px-3 py-2 border border-gray-darkShow rounded-xl flex space-x-2" }
const _hoisted_19 = { class: "table text-sm" }
const _hoisted_20 = { class: "table-cell align-middle" }
const _hoisted_21 = { class: "absolute bottom-8 w-full p-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "table-cell align-middle text-white text-sm font-bold" }, " 適用 ")
], -1)
const _hoisted_23 = [
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdjustmentsHorizontalIcon = _resolveComponent("AdjustmentsHorizontalIcon")!
  const _component_ChevronUpDownIcon = _resolveComponent("ChevronUpDownIcon")!
  const _component_ListboxButton = _resolveComponent("ListboxButton")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_ListboxOption = _resolveComponent("ListboxOption")!
  const _component_ListboxOptions = _resolveComponent("ListboxOptions")!
  const _component_Listbox = _resolveComponent("Listbox")!
  const _component_ComboboxLabel = _resolveComponent("ComboboxLabel")!
  const _component_ComboboxInput = _resolveComponent("ComboboxInput")!
  const _component_ComboboxButton = _resolveComponent("ComboboxButton")!
  const _component_ComboboxOption = _resolveComponent("ComboboxOption")!
  const _component_ComboboxOptions = _resolveComponent("ComboboxOptions")!
  const _component_Combobox = _resolveComponent("Combobox")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "flex justify-center bg-gray-showButton py-2 px-4 rounded w-max space-x-2 m-auto relative",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openFilterEditor()))
      }, [
        _createVNode(_component_AdjustmentsHorizontalIcon, { class: "h-6 w-6 text-white" }),
        _hoisted_2,
        (_ctx.filters.tags.length !== 0 || _ctx.filters.category)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.filters.category ? _ctx.filters.tags.length + 1 : _ctx.filters.tags.length), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.isShowFilterEditor,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isShowFilterEditor) = $event)),
      position: "bottom",
      style: {height: '70%'},
      closeable: true,
      round: true,
      class: "bg-gray-lightShow",
      onClosed: _ctx.discardChanges
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("p", {
                  class: "block text-left text-xs font-bold text-gray-showButton",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetCategory && _ctx.resetCategory(...args)))
                }, " リセット ")
              ]),
              _createVNode(_component_Listbox, {
                modelValue: _ctx.selectedFilters.category,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedFilters.category) = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_ListboxButton, { class: "w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-green-show :outline-none focus:ring-1 focus:ring-green-show sm:text-sm" }, {
                      default: _withCtx(() => [
                        (_ctx.selectedFilters.category)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.selectedFilters.category.name), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_12, " カテゴリー ")),
                        _createElementVNode("span", _hoisted_13, [
                          _createVNode(_component_ChevronUpDownIcon, {
                            class: "h-5 w-5 text-gray-400",
                            "aria-hidden": "true"
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_Transition, {
                      "leave-active-class": "transition duration-100 ease-in",
                      "leave-from-class": "opacity-100",
                      "leave-to-class": "opacity-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ListboxOptions, { class: "absolute z-30 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.voucherCategories, (voucherCategory) => {
                              return (_openBlock(), _createBlock(_component_ListboxOption, {
                                key: voucherCategory.name,
                                value: voucherCategory,
                                as: "template"
                              }, {
                                default: _withCtx(({active, selected}) => [
                                  _createElementVNode("li", {
                                    class: _normalizeClass([
                          active ? 'bg-green-show text-white' : 'text-gray-900',
                          'relative cursor-default select-none py-2 pl-10 pr-4',
                        ])
                                  }, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass([
                            selected ? 'font-medium' : 'font-normal',
                            'block truncate text-left',
                          ])
                                    }, _toDisplayString(voucherCategory.name), 3),
                                    selected
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                          _createVNode(_component_CheckIcon, {
                                            class: "h-5 w-5",
                                            "aria-hidden": "true"
                                          })
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 2)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_Combobox, {
                modelValue: _ctx.selectedFilters.tags,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedFilters.tags) = $event)),
                as: "div",
                multiple: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ComboboxLabel, { class: "block text-left text-sm font-bold text-gray-showButton" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" タグでフィルタリング ")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_ComboboxInput, {
                      class: "w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-green-show :outline-none focus:ring-1 focus:ring-green-show sm:text-sm",
                      "display-value": (tag) => tag?.name,
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.query = $event.target.value))
                    }, null, 8, ["display-value"]),
                    _createVNode(_component_ComboboxButton, { class: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ChevronUpDownIcon, {
                          class: "h-5 w-5 text-gray-400",
                          "aria-hidden": "true"
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ComboboxOptions, { class: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTags.slice(0, 100), (tag) => {
                          return (_openBlock(), _createBlock(_component_ComboboxOption, {
                            key: tag.voucherTagId,
                            value: tag,
                            as: "template"
                          }, {
                            default: _withCtx(({active, selected}) => [
                              _createElementVNode("li", {
                                class: _normalizeClass([
                        'relative cursor-default select-none py-2 pl-3 pr-9 text-left',
                        active ? 'bg-green-show text-white' : 'text-gray-900',
                      ])
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(['block truncate', selected && 'font-semibold'])
                                }, _toDisplayString(tag.name), 3),
                                selected
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass([
                          'absolute inset-y-0 right-0 flex items-center pr-4',
                          active ? 'text-white' : 'text-green-show',
                        ])
                                    }, [
                                      _createVNode(_component_CheckIcon, {
                                        class: "h-5 w-5",
                                        "aria-hidden": "true"
                                      })
                                    ], 2))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFilters.tags, (tag) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: tag.voucherTagId,
                      class: "mr-2 mt-2"
                    }, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("p", _hoisted_20, "#" + _toDisplayString(tag.name), 1)
                        ]),
                        _createVNode(_component_XMarkIcon, {
                          class: "w-4 h-4 m-auto",
                          onClick: ($event: any) => (_ctx.removeSelectedTag(tag.name))
                        }, null, 8, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", {
              class: "flex justify-center bg-green-show py-3 px-4 rounded w-full space-x-2 m-auto relative",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveFilterTags && _ctx.saveFilterTags(...args)))
            }, _hoisted_23)
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "onClosed"])
  ]))
}